/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowParallelHIcon20Light = forwardRef('ArrowParallelHIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M12.283 1.752a.5.5 0 1 1 .707-.708l3.273 3.273a1.672 1.672 0 0 1 0 2.365L12.99 9.955a.5.5 0 1 1-.707-.707L15.531 6H3.75a.5.5 0 1 1 0-1h11.781l-3.248-3.248Z" }),
        React.createElement("path", { d: "M7.717 10.752a.5.5 0 1 0-.707-.707l-3.273 3.273a1.672 1.672 0 0 0 0 2.364l3.273 3.273a.5.5 0 1 0 .707-.707L4.469 15h11.78a.5.5 0 1 0 0-1H4.47l3.248-3.248Z" })));
});
